<h4 class="m-top-15" *ngIf="showHeader === true">Monthly Overview</h4>

<div class="table-container">
  <table class="session-log-user-stickiness" width="100%">
    <thead>
      <tr>
        <th>Month End</th>
        <th>Total Users</th>
        <th>Unique Users last 28 Days</th>
        <th>MAU/Total %</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let day of dataDisplay">
        <th>{{day.date | date:'MMMM yyyy'}}</th>
        <td class="cell-divider">{{day.totalUsers}}</td>
        <td>{{day.monthlyActiveUsers}}</td>
        <td class="cell-divider">{{calculateMonthlyActiveVsTotal(day)}}</td>
      </tr>
    </tbody>
  </table>
</div>